(function(){
    "use strict";
    
    angular
        .module("app")
        .component("productSearch", { // product-search
            bindings: {
                productType: "@",
                productClass: "@"
            },
            templateUrl: "src/app/productSearch/productSearch.html",
            controller: controller
        });

    function controller($routeParams, $uibModal, session, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;
        //$ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
        
        

        $ctrl.$onInit = () => {

            session.products.searchCriteria.cs = $ctrl.productType === CART_TYPE_CODE.CSOS;
            session.products.searchCriteria.classId = $ctrl.productClass == null ? null : parseInt($ctrl.productClass);

            //const modalInstance = $uibModal.open({
            //    template:
            //        `<premier-modal on-dismiss="$ctrl.dismiss()" on-close="$ctrl.close(result)"></premier-modal>`,
            //    controller: [
            //        "$uibModalInstance", function ($uibModalInstance) {
            //            const ctrl = this;
            //            ctrl.dismiss = $uibModalInstance.dismiss;
            //            ctrl.close = result => $uibModalInstance.close(result);
            //        }
            //    ],
            //    controllerAs: "$ctrl"
            //});

            //session.products.searchCriteria.classId = null;
            //let searchText = session.products.searchCriteria.searchText;

            //if (!session.products.searchCriteria.searchText && !!$routeParams.searchText)
            //    searchText = decodeURI($routeParams.searchText);
            //else if (!$routeParams.searchText) 
            //    searchText = "";

            //if (session.products.searchCriteria.cs) {
            //    session
            //        .setCartType(CART_TYPE_CODE.CSOS)
            //        .then(() => {
            //            session.products.searchCriteria.searchText = searchText;
            //            session.products.search();
            //        });
            //} else {
            //    session
            //        .setCartType(CART_TYPE_CODE.RX)
            //        .then(() => {
            //            session.products.searchCriteria.searchText = searchText;
            //            session.products.searchAll();
            //        });
            //}
        };

        $ctrl.showBonusIncentive = () => {
            return session.customer && session.customer.has_bonus_discount;
        };

        $ctrl.bonusProgressPct = () => {
            return Math.round(session.customer.bonus_discount_current_amount / session.customer.bonus_discount_goal_amount*100);
        };

        $ctrl.showBonusDiscountDetails = () => {
            const modalInstance = $uibModal.open({
                template:
                    `<bonus-discount-details-modal on-dismiss="$ctrl.dismiss()" on-close="$ctrl.close(result)"></bonus-discount-details-modal>`,
                controller: [
                    "$uibModalInstance", function($uibModalInstance) {
                        const ctrl = this;
                        ctrl.dismiss = $uibModalInstance.dismiss;
                        ctrl.close = result => $uibModalInstance.close(result);
                    }
                ],
                controllerAs: "$ctrl"
            });

            modalInstance.result
                .then(function(result) {
                    //console.log("modalInstance.result", result);
                });
        };

        //$ctrl.productSelected = cartTypeCode => {
        //    session
        //        .setCartType(cartTypeCode)
        //        .then(() => {
        //            session.products.searchCriteria.searchText = "";
        //            session.gotoProductSearch();
        //        });
        //};
    }
    controller.$inject = ["$routeParams", "$uibModal", "sessionService", "CART_TYPE_CODE"];
    
})()